import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'ant-design-vue/dist/antd.css'
import axios from './api/axios'
import VueI18n from 'vue-i18n'
import VueLazyload from 'vue-lazyload'
import {
  Button,
  Modal,
  Input,
  FormModel,
  Select,
  Form,
  Spin,
  Icon,
  message
} from 'ant-design-vue'
Vue.component(Icon.name, Icon)
Vue.component(Button.name, Button)
Vue.component(Input.name, Input)
Vue.component(FormModel.name, FormModel)
Vue.component(FormModel.Item.name, FormModel.Item)
Vue.component(Spin.name, Spin)
Vue.use(Modal)
Vue.component(Select.name, Select)
Vue.component(Form.name, Form)
Vue.component(Select.Option.name, Select.Option)
Vue.use(VueI18n)
Vue.use(VueLazyload, {
  loading: require('@/assets/loading.gif') // 图片加载中显示
})

const i18n = new VueI18n({
  locale: localStorage.getItem('languageSet') || 'en-CN',
  messages: {
    'zh-CN': require('./assets/language/zh'), // 通过require引入中文语言包
    'en-US': require('./assets/language/en') // 通过require引入英文语言包
  }
})
Vue.prototype.$axios = axios
Vue.prototype.$message = message
Vue.config.productionTip = false
function setWindowSize () {
  // 根据设备的宽度设置fontsize
  let width = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth
  const count = 750 / 16
  if (width > 1200) {
    width = 1200
  }
  document.documentElement.style.fontSize = `${width / count}px `
}

setWindowSize()

window.addEventListener('resize', () => {
  setWindowSize()
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
